import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Link } from 'react-router-dom'
import { 
  Container, 
  TextField, 
  Button, 
  Typography, 
  Box, 
  Alert 
} from '@mui/material'

// Çoklu dil desteği
import { useTranslation } from 'react-i18next'

export default function ForgotPassword() {
  const { t } = useTranslation()  // i18n Hook

  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const { resetPassword } = useAuth()

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setMessage('')
      setError('')
      await resetPassword(email)
      setMessage(t('forgotPasswordPage.successReset')) // "Daha fazla talimat için emailinizi kontrol edin."
    } catch (err) {
      setError(t('forgotPasswordPage.errorReset')) // "Şifre sıfırlanamadı"
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #fdfbfb 0%, #f3f4f6 40%, #e0f2fe 100%)',
        px: 2
      }}
    >
      <Container maxWidth="xs" disableGutters>
        <Box
          sx={{
            p: { xs: 3, sm: 4 },
            borderRadius: 4,
            boxShadow: '0 18px 45px rgba(15,23,42,0.18)',
            backgroundColor: 'rgba(255,255,255,0.96)',
            border: '1px solid rgba(148,163,184,0.25)',
            backdropFilter: 'blur(10px)',
            textAlign: 'center'
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
            {t('forgotPasswordPage.title')}
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2, borderRadius: 3 }}>
              {error}
            </Alert>
          )}
          {message && (
            <Alert severity="success" sx={{ mb: 2, borderRadius: 3 }}>
              {message}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              type="email"
              label={t('forgotPasswordPage.emailLabel')}
              variant="outlined"
              fullWidth
              sx={{
                mb: 2,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 3,
                  backgroundColor: 'rgba(248,250,252,0.9)'
                }
              }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                py: 1.3,
                mb: 1,
                borderRadius: 999,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.95rem',
                boxShadow: '0 14px 30px rgba(37,99,235,0.4)'
              }}
            >
              {t('forgotPasswordPage.resetButton')}
            </Button>
          </form>

          <Typography variant="body2" sx={{ mt: 2 }}>
            <Link to="/login" style={{ textDecoration: 'none' }}>
              <span style={{ fontWeight: 600, color: '#2563eb' }}>
                {t('forgotPasswordPage.loginLink')}
              </span>
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}